import React, { cloneElement, useEffect, useRef, } from 'react';
const eventTypeMapping = {
    click: 'onClick',
    focusin: 'onFocus',
    focusout: 'onFocus',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    touchstart: 'onTouchStart',
    touchend: 'onTouchEnd',
};
const ClickAwayListener = ({ children, onClickAway, focusEvent = 'focusin', mouseEvent = 'click', touchEvent = 'touchend', }) => {
    const node = useRef(null);
    const bubbledEventTarget = useRef(null);
    const mountedRef = useRef(false);
    useEffect(() => {
        setTimeout(() => {
            mountedRef.current = true;
        }, 0);
        return () => {
            mountedRef.current = false;
        };
    }, []);
    const handleBubbledEvents = (type) => (event) => {
        bubbledEventTarget.current = event.target;
        const handler = children === null || children === void 0 ? void 0 : children.props[type];
        if (handler) {
            handler(event);
        }
    };
    const handleChildRef = (childRef) => {
        node.current = childRef;
        const { ref } = children;
        if (typeof ref === 'function') {
            ref(childRef);
        }
        else if (ref) {
            ref.current = childRef;
        }
    };
    useEffect(() => {
        var _a, _b;
        const nodeDocument = (_b = (_a = node.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) !== null && _b !== void 0 ? _b : document;
        const handleEvents = (event) => {
            if (!mountedRef.current)
                return;
            if ((node.current && node.current.contains(event.target)) ||
                bubbledEventTarget.current === event.target ||
                !nodeDocument.contains(event.target)) {
                return;
            }
            onClickAway(event);
        };
        nodeDocument.addEventListener(mouseEvent, handleEvents);
        nodeDocument.addEventListener(touchEvent, handleEvents);
        nodeDocument.addEventListener(focusEvent, handleEvents);
        return () => {
            nodeDocument.removeEventListener(mouseEvent, handleEvents);
            nodeDocument.removeEventListener(touchEvent, handleEvents);
            nodeDocument.removeEventListener(focusEvent, handleEvents);
        };
    }, [focusEvent, mouseEvent, onClickAway, touchEvent]);
    const mappedMouseEvent = eventTypeMapping[mouseEvent];
    const mappedTouchEvent = eventTypeMapping[touchEvent];
    const mappedFocusEvent = eventTypeMapping[focusEvent];
    return React.Children.only(cloneElement(children, {
        ref: handleChildRef,
        [mappedFocusEvent]: handleBubbledEvents(mappedFocusEvent),
        [mappedMouseEvent]: handleBubbledEvents(mappedMouseEvent),
        [mappedTouchEvent]: handleBubbledEvents(mappedTouchEvent),
    }));
};
ClickAwayListener.displayName = 'ClickAwayListener';
export default ClickAwayListener;
//# sourceMappingURL=index.js.map